module.exports = __webpack_public_path__ + "img/1ed633c.png";